export default {
  opened: {
    label: 'w przygotowaniu',
    description: 'Przygotuj swoje zamówienie.'
  },
  offer: {
    label: 'zapytanie ofertowe',
    description: 'Idywidualna oferta jest w trakcie przygotowania. '
  },
  offered: {
    label: 'oferta gotowa',
    description: 'Oferta gotowa, prosimy o zatwierdzenie.'
  },
  requested: {
    label: 'oczekuje na potwierdzenie',
    description: 'Weryfikacja warunków sprzedaży zamówionych produktów.'
  },
  confirmed: {
    label: 'zamówienie potwierdzone',
    description: 'Przygotowanie zamównienia do wysyłki.'
  },
  collected: {
    label: 'gotowe do wysyłki',
    description: 'Zamówienie oczekuje na dostarczenie, z uwzględnieniem wymaganych warunków transportu.'
  },
  sent: {
    label: 'wysłane',
    description: 'Towar w trakcie dostarczania.'
  },
  completed: { label: 'zrealizowane' },
  rejected: {
    label: 'odrzucone',
    description: 'Oferta została odrzucona lub nie mogła być zrealizowana ze wzgędu na wymagania formalne.'
  },
  cancelled: { label: 'anulowane' }
}



// WEBPACK FOOTER //
// ./src/store/cart-statuses.js